import {
  faCheckCircle,
  faCircle,
  faMinusCircle,
  faPlusCircle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WhiteBox from "../../../../components/WhiteBox";
import {
  Button,
  Col2Grid,
  Description,
  DropHere,
  FH,
  Input,
  Label,
  Text,
  Title,
} from "../../../main-styles";

import WYSEditor from "../../../../components/Editor";
import { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { useNavigate, useParams } from "react-router";
import toast from "react-hot-toast";
import {
  createProduto,
  getProduto,
  updateProduto,
  getProductVariants,
  createProductVariant,
  updateProductVariant,
  deleteProductVariant,
  getAttributeTypes,
  createAttributeType,
  deleteAttributeType,
  getAttributeValues,
} from "../../../../api/produtos";
import { uploadToS3 } from "../../../../api/utils";
import VideoMinuatureView from "../../../../components/VideoMinuatureView";
import BackButton from "../../../../components/BackButton";
import { useConfirm } from "../../../../components/ConfirmProvider";

function Novo({ edit }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const confirm = useConfirm();
  const [html, setHtml] = useState("");
  const [newVideoUrl, setNewVideoUrl] = useState("");
  const [imagesToUpload, setImagesToUpload] = useState([]);
  window.document.title = `Organnact - Admin - ${
    edit ? "Editar produto" : "Adicionar novo produto"
  }`;
  const [state, setState] = useState({
    nome: "",
    preco: "",
    precoPromocional: "",
    codigo: "",
    quantidade_minima: "",
    imagens: [],
    videos: [],
    destaque: false,
    tipo: [],
    status: "active",
    loading: true,
  });
  const [variants, setVariants] = useState([]);
  const [attributeTypes, setAttributeTypes] = useState([]);
  const [newAttributeType, setNewAttributeType] = useState("");
  const [attrValues, setAttrValues] = useState([]); // valores existentes por tipo
  const [selectedValues, setSelectedValues] = useState({}); // { id_attribute_type: [val1, val2] }

  const {
    nome,
    preco,
    precoPromocional,
    codigo,
    quantidade_minima,
    imagens,
    videos,
    loading,
    destaque,
    tipo,
    status,
  } = state;

  useEffect(() => {
    _loadAttributeTypes();
    if (edit) {
      loadProduto();
    } else {
      setState({
        nome: "",
        preco: "",
        precoPromocional: "",
        codigo: "",
        quantidade_minima: "",
        imagens: [],
        videos: [],
        tipo: [],
        status: "active",
        loading: false,
      });
      setVariants([]);
    }
  }, [id]);

  async function _loadAttributeTypes() {
    try {
      const types = await getAttributeTypes();
      setAttributeTypes(types);
    } catch (error) {
      console.error("Error loading attribute types:", error);
    }
    try {
      const vals = await getAttributeValues();
      setAttrValues(vals);
    } catch (error) {
      console.error("Error loading attribute values:", error);
    }
  }

  async function _loadVariants() {
    try {
      const vars = await getProductVariants(id);
      setVariants(vars || []);
    } catch (error) {
      console.error("Error loading variants:", error);
    }
  }

  async function loadProduto() {
    setState((prevState) => ({ ...prevState, loading: true }));
    try {
      let nproduto = await getProduto(id);
      setState({
        nome: nproduto.nome,
        preco: nproduto.preco,
        precoPromocional: nproduto.precoPromocional,
        codigo: nproduto.id_everest,
        quantidade_minima: nproduto.quantidade_minima ?? "",
        imagens: nproduto.imagens || [],
        destaque: nproduto.destaque || false,
        videos: nproduto.videos || [],
        tipo: nproduto.tipo || [],
        status: nproduto.status || "active",
        loading: false,
      });
      setHtml(nproduto.descricao || "");
      setImagesToUpload([]);
      // Load variants for this product
      try {
        const vars = await getProductVariants(id);
        setVariants(vars || []);
      } catch (e) {
        console.error("Error loading variants:", e);
      }
    } catch (error) {
      toast.error("Erro ao carregar produto");
      navigate("/admin/produtos");
    }
  }

  function updateField(field, value, integer = false) {
    if (integer && value) {
      value = parseFloat(value.replace(",", "."));
      if (isNaN(value)) {
        toast.error("O valor deve ser um número inteiro válido");
        return;
      }
    }
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  // mantem o preco como texto enquanto digita, senao o parseFloat come a virgula ("2," vira 2)
  function updatePreco(value) {
    value = value.replace(",", ".");
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    setState((prevState) => ({ ...prevState, preco: value }));
  }

  function addVideUrl() {
    // validate URL format
    if (
      !newVideoUrl ||
      !/^https?:\/\/(www\.)?youtube\.com\/watch\?v=/.test(newVideoUrl)
    ) {
      toast.error("O link do vídeo deve ser um link válido do YouTube");
      return;
    }
    setState((prevState) => ({
      ...prevState,
      videos: [...prevState.videos, newVideoUrl],
    }));
    setNewVideoUrl("");
  }

  function removeVideoUrl(videoUrl) {
    setState((prevState) => ({
      ...prevState,
      videos: prevState.videos.filter((v) => v !== videoUrl),
    }));
  }

  const handleChange = (html) => {
    setHtml(html);
  };

  function validate() {
    if (!codigo) {
      toast.error(
        "O código do produto é obrigatório e deve ser igual ao everest"
      );
      return false;
    }
    if (!nome) {
      toast.error("O nome do produto é obrigatório");
      return false;
    }
    if (!preco || isNaN(preco)) {
      toast.error("O preço do produto deve ser um número válido");
      return false;
    }
    if (imagesToUpload.length === 0 && imagens.length === 0) {
      toast.error("Pelo menos uma imagem é obrigatória");
      return false;
    }
    if (!tipo || tipo.length === 0) {
      toast.error("Selecione pelo menos um tipo (PET ou EQUI)");
      return false;
    }
    return true;
  }

  async function save() {
    if (!validate()) return;
    const imageLinks = await uploadToS3(imagesToUpload);
    const finalImages = [...imagens, ...imageLinks];
    const payload = {
      id,
      id_everest: codigo,
      nome,
      preco: parseFloat(preco),
      quantidade_minima:
        quantidade_minima === "" || quantidade_minima === null
          ? null
          : parseInt(quantidade_minima, 10),
      imagens: finalImages,
      videos,
      descricao: html,
      status,
      destaque,
      tipo,
    };
    if (edit) {
      // update existing
      let response = await updateProduto(payload);
      if (response) {
        toast.success("Produto atualizado com sucesso!");
        navigate("/admin/produtos");
      } else {
        toast.error("Erro ao atualizar produto");
      }
    } else {
      // save new
      let response = await createProduto(payload);
      if (response) {
        toast.success("Produto adicionado com sucesso!");
        navigate("/admin/produtos");
      } else {
        toast.error("Erro ao adicionar produto");
      }
    }
    console.log("Payload to save:", payload);
  }

  if (loading) {
    return (
      <WhiteBox style={{ padding: 20, marginTop: 20, textAlign: "center" }}>
        <Spinner />
      </WhiteBox>
    );
  }

  function handleRemoveImage(img, isUploaded) {
    if (isUploaded) {
      setState((prevState) => ({
        ...prevState,
        imagens: prevState.imagens.filter((i) => i !== img),
      }));
    } else {
      setImagesToUpload((prev) => prev.filter((i) => (i.preview || i) !== img));
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ marginTop: 20 }}>
        <BackButton />
      </div>

      <Col2Grid>
        <WhiteBox>
          <Label>Código do produto (Deve ser igual ao everest)</Label>
          <Input
            value={codigo}
            onChange={(e) => updateField("codigo", e.target.value)}
            placeholder="Ex: 123456"
          />

          <Label>Nome do produto</Label>
          <Input
            value={nome}
            onChange={(e) => updateField("nome", e.target.value)}
            placeholder="Ex: Produto X"
          />

          <Label>Preço</Label>
          <Input
            value={preco}
            onChange={(e) => updatePreco(e.target.value)}
            placeholder="Ex: 100 ou 2,50"
          />

          <Label>Quantidade mínima de compra</Label>
          <Input
            value={quantidade_minima}
            onChange={(e) =>
              updateField("quantidade_minima", e.target.value, true)
            }
            placeholder="Ex: 10 (deixe vazio para 1)"
          />

          <div
            onClick={() => updateField("destaque", !destaque)}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              marginTop: 8,
              marginBottom: 8,
              borderRadius: 8,
              border: destaque ? "2px solid #ff5900" : "2px solid #ddd",
              backgroundColor: destaque ? "#fff3ef" : "#fafafa",
              transition: "all 0.2s",
            }}
          >
            <FontAwesomeIcon
              icon={destaque ? faCheckCircle : faCircle}
              style={{ fontSize: 22, color: destaque ? "#ff5900" : "#ccc" }}
            />
            <div>
              <div style={{ fontSize: 15, fontWeight: 600, color: destaque ? "#ff5900" : "#555" }}>
                Destacar produto
              </div>
              <div style={{ fontSize: 12, color: "#999", marginTop: 2 }}>
                Produtos em destaque aparecem no carousel da pagina inicial
              </div>
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <Label>Status do produto</Label>
            <div>
              <select
                value={status}
                onChange={(e) => updateField("status", e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  fontSize: 14,
                  border: "1px solid #ddd",
                  borderRadius: 6,
                  marginBottom: 16,
                  background: "#fff",
                }}
              >
                <option value="active">Ativo</option>
                <option value="pre_lancamento">Pré-venda</option>
                <option value="inactive">Inativo</option>
              </select>
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <Label>Tipo (Divisão)</Label>
            <FH style={{ gap: 10 }}>
              <Label
                style={{ cursor: "pointer", fontSize: 14 }}
                onClick={() => {
                  const newTipo = tipo.includes("pet")
                    ? tipo.filter((t) => t !== "pet")
                    : [...tipo, "pet"];
                  updateField("tipo", newTipo);
                }}
              >
                <FontAwesomeIcon
                  icon={tipo.includes("pet") ? faCheckCircle : faCircle}
                />{" "}
                PET
              </Label>
              <Label
                style={{ cursor: "pointer", fontSize: 14 }}
                onClick={() => {
                  const newTipo = tipo.includes("equi")
                    ? tipo.filter((t) => t !== "equi")
                    : [...tipo, "equi"];
                  updateField("tipo", newTipo);
                }}
              >
                <FontAwesomeIcon
                  icon={tipo.includes("equi") ? faCheckCircle : faCircle}
                />{" "}
                EQUI
              </Label>
            </FH>
          </div>
        </WhiteBox>
        <WhiteBox>
          <Label>Imagens</Label>
          <div>
            {[...imagens, ...imagesToUpload.map((i) => i.preview || i)].map(
              (img, index) => {
                const isUploaded = index < imagens.length;
                return (
                  <div
                    key={index}
                    style={{
                      position: "relative",
                      display: "inline-block",
                      marginRight: 8,
                    }}
                  >
                    <img
                      src={img}
                      alt={`preview-${index}`}
                      style={{
                        maxHeight: 100,
                        marginBottom: 8,
                        width: 100,
                        height: 100,
                        objectFit: "cover",
                        borderRadius: 4,
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faMinusCircle}
                      color="red"
                      style={{
                        position: "absolute",
                        top: 2,
                        right: 2,
                        fontSize: 18,
                        cursor: "pointer",
                        background: "#fff",
                        borderRadius: "50%",
                      }}
                      onClick={() => handleRemoveImage(img, isUploaded)}
                    />
                  </div>
                );
              }
            )}
          </div>
          <DropHere
            onClick={() => document.getElementById("imageInput").click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const files = Array.from(e.dataTransfer.files).filter((file) =>
                file.type.startsWith("image/")
              );
              const newImages = files.map((file) => {
                const url = URL.createObjectURL(file);
                return {
                  file,
                  preview: url,
                };
              });
              setImagesToUpload((prev) => [...prev, ...newImages]);
            }}
          >
            <Text>Arraste e solte as imagens aqui</Text>
            <Text style={{ fontSize: 12, color: "#999", marginLeft: 10 }}>
              ou clique para selecionar
            </Text>
            <input
              id="imageInput"
              type="file"
              multiple
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => {
                const files = Array.from(e.target.files);
                const newImages = files.map((file) => {
                  const url = URL.createObjectURL(file);
                  return {
                    file,
                    preview: url,
                  };
                });
                setImagesToUpload((prev) => [...prev, ...newImages]);
              }}
            />
          </DropHere>
          <Label style={{ marginTop: 16 }}>Vídeos</Label>
          <div
            style={{
              width: "100%",
              marginBottom: 16,
              display: "flex",
              flexDirection: "column",
              gap: 5,
            }}
          >
            {videos.map((video, index) => (
              <FH
                style={{
                  flex: 1,
                  backgroundColor: "#f9f9f9",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 12,
                }}
                key={index}
              >
                <VideoMinuatureView videoUrl={video} />
                <FontAwesomeIcon
                  icon={faMinusCircle}
                  color="red"
                  style={{ fontSize: 14, cursor: "pointer" }}
                  onClick={() => removeVideoUrl(video)}
                />
              </FH>
            ))}
          </div>
          <Description>
            Adicione o link completo do vídeo no youtube
          </Description>
          <FH style={{ gap: 10, alignItems: "center" }}>
            <Input
              value={newVideoUrl}
              onChange={(e) => setNewVideoUrl(e.target.value)}
            />
            <FontAwesomeIcon
              icon={faPlusCircle}
              color="#ccc"
              style={{ marginBottom: 16, fontSize: 20, cursor: "pointer" }}
              onClick={addVideUrl}
            />
          </FH>
        </WhiteBox>
      </Col2Grid>

      {edit && (
        <WhiteBox>
          <FH style={{ justifyContent: "space-between", alignItems: "center" }}>
            <Title>Variantes do Produto</Title>
            <FH style={{ gap: 10, alignItems: "center" }}>
              <Label>Tipos de atributo:</Label>
              <Input
                style={{ width: 150, marginBottom: 0 }}
                placeholder="Ex: Tamanho"
                value={newAttributeType}
                onChange={(e) => setNewAttributeType(e.target.value)}
              />
              <FontAwesomeIcon
                icon={faPlusCircle}
                color="#3483fa"
                style={{ fontSize: 20, cursor: "pointer" }}
                onClick={async () => {
                  if (!newAttributeType.trim()) return;
                  try {
                    await createAttributeType(newAttributeType.trim());
                    setNewAttributeType("");
                    _loadAttributeTypes();
                    toast.success("Tipo de atributo criado!");
                  } catch (e) {
                    toast.error("Erro ao criar tipo de atributo");
                  }
                }}
              />
            </FH>
          </FH>
          {attributeTypes.length > 0 && (
            <FH style={{ gap: 5, marginBottom: 10, flexWrap: "wrap" }}>
              {attributeTypes.map((at) => (
                <span
                  key={at.id}
                  style={{
                    backgroundColor: "#f0f0f0",
                    padding: "2px 8px",
                    borderRadius: 4,
                    fontSize: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                  }}
                >
                  {at.nome}
                  <FontAwesomeIcon
                    icon={faMinusCircle}
                    color="red"
                    style={{ cursor: "pointer", fontSize: 12 }}
                    onClick={async () => {
                      if (
                        !(await confirm({
                          title: "Remover tipo",
                          message: `Remover tipo "${at.nome}"?`,
                          confirmText: "Remover",
                          danger: true,
                        }))
                      )
                        return;
                      try {
                        await deleteAttributeType(at.id);
                        _loadAttributeTypes();
                      } catch (e) {
                        toast.error("Erro ao remover tipo de atributo");
                      }
                    }}
                  />
                </span>
              ))}
            </FH>
          )}

          {attrValues.length > 0 && (
            <div style={{
              background: "#f9f9f9",
              borderRadius: 8,
              padding: 16,
              marginBottom: 16,
              border: "1px solid #eee",
            }}>
              <Label style={{ marginBottom: 10, display: "block", fontWeight: 500, fontSize: 13, color: "#333" }}>
                Selecionar variantes existentes
              </Label>
              {attrValues.map((av) => (
                <div key={av.id} style={{ marginBottom: 12 }}>
                  <Label style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" }}>
                    {av.nome}:
                  </Label>
                  <FH style={{ gap: 6, flexWrap: "wrap" }}>
                    {av.valores.map((val) => {
                      const isSelected = (selectedValues[av.id] || []).includes(val);
                      return (
                        <span
                          key={val}
                          onClick={() => {
                            setSelectedValues((prev) => {
                              const current = prev[av.id] || [];
                              if (current.includes(val)) {
                                return { ...prev, [av.id]: current.filter((v) => v !== val) };
                              }
                              return { ...prev, [av.id]: [...current, val] };
                            });
                          }}
                          style={{
                            padding: "5px 12px",
                            borderRadius: 20,
                            fontSize: 13,
                            fontWeight: 500,
                            cursor: "pointer",
                            border: isSelected ? "2px solid #3483fa" : "1px solid #ccc",
                            backgroundColor: isSelected ? "#e0f2f1" : "#fff",
                            color: isSelected ? "#3483fa" : "#555",
                            transition: "all 0.15s ease",
                            userSelect: "none",
                          }}
                        >
                          {val}
                        </span>
                      );
                    })}
                  </FH>
                </div>
              ))}
              <Button
                style={{
                  marginTop: 8,
                  backgroundColor: "#3483fa",
                  fontSize: 13,
                  padding: "8px 16px",
                }}
                onClick={() => {
                  // gerar combinacoes cartesianas dos valores selecionados
                  const attrIds = Object.keys(selectedValues).filter(
                    (k) => selectedValues[k]?.length > 0
                  );
                  if (attrIds.length === 0) {
                    toast.error("Selecione pelo menos um valor");
                    return;
                  }
                  const arrays = attrIds.map((id) =>
                    selectedValues[id].map((val) => ({
                      id_attribute_type: parseInt(id),
                      nome: attrValues.find((a) => a.id === parseInt(id))?.nome || "",
                      valor: val,
                    }))
                  );
                  // produto cartesiano
                  const combos = arrays.reduce(
                    (acc, curr) =>
                      acc.flatMap((a) => curr.map((c) => [...a, c])),
                    [[]]
                  );
                  const newVariants = combos.map((combo) => ({
                    id_everest: "",
                    preco: preco || "",
                    status: "active",
                    attributes: attributeTypes.map((at) => {
                      const match = combo.find(
                        (c) => c.id_attribute_type === at.id
                      );
                      return {
                        id_attribute_type: at.id,
                        nome: at.nome,
                        valor: match?.valor || "",
                      };
                    }),
                  }));
                  setVariants((prev) => [...prev, ...newVariants]);
                  setSelectedValues({});
                  toast.success(`${newVariants.length} variante(s) gerada(s)`);
                }}
              >
                Gerar variantes selecionadas
              </Button>
            </div>
          )}

          <table className="table table-sm" style={{ fontSize: 13 }}>
            <thead>
              <tr>
                <th>Código Everest</th>
                <th>Preço</th>
                {attributeTypes.map((at) => (
                  <th key={at.id}>{at.nome}</th>
                ))}
                <th>Status</th>
                <th style={{ textAlign: "right" }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {variants.map((v, idx) => (
                <VariantRow
                  key={v.id || `new-${idx}`}
                  variant={v}
                  attributeTypes={attributeTypes}
                  onSave={async (variantData) => {
                    try {
                      if (v.id) {
                        await updateProductVariant(v.id, variantData);
                        toast.success("Variante atualizada!");
                      } else {
                        await createProductVariant(id, variantData);
                        toast.success("Variante criada!");
                      }
                      _loadVariants();
                    } catch (e) {
                      toast.error("Erro ao salvar variante");
                    }
                  }}
                  onDelete={async () => {
                    if (!v.id) {
                      setVariants((prev) => prev.filter((_, i) => i !== idx));
                      return;
                    }
                    if (
                      !(await confirm({
                        title: "Remover variante",
                        message: "Remover esta variante?",
                        confirmText: "Remover",
                        danger: true,
                      }))
                    )
                      return;
                    try {
                      await deleteProductVariant(v.id);
                      _loadVariants();
                      toast.success("Variante removida!");
                    } catch (e) {
                      toast.error("Erro ao remover variante");
                    }
                  }}
                />
              ))}
              {variants.length === 0 && (
                <tr>
                  <td
                    colSpan={3 + attributeTypes.length}
                    style={{ textAlign: "center", color: "#999" }}
                  >
                    Nenhuma variante cadastrada. Este produto usa código e preço
                    únicos.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Button
            style={{ backgroundColor: "#f0f0f0", color: "#333", marginTop: 10 }}
            onClick={() =>
              setVariants((prev) => [
                ...prev,
                {
                  id_everest: "",
                  preco: "",
                  status: "active",
                  attributes: attributeTypes.map((at) => ({
                    id_attribute_type: at.id,
                    nome: at.nome,
                    valor: "",
                  })),
                },
              ])
            }
          >
            <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: 5 }} />
            Adicionar variante
          </Button>
        </WhiteBox>
      )}

      <WhiteBox>
        <Label>Descrição</Label>
        <WYSEditor
          value={html}
          onChange={handleChange}
          style={{
            overlow: "auto",
          }}
        />
        <Button style={{ marginTop: 20 }} onClick={save}>
          {edit ? "Salvar" : "Adicionar"}
        </Button>
      </WhiteBox>
    </div>
  );
}

function VariantRow({ variant, attributeTypes, onSave, onDelete }) {
  const [data, setData] = useState({
    id_everest: variant.id_everest || "",
    preco: variant.preco || "",
    status: variant.status || "active",
    attributes: attributeTypes.map((at) => {
      const existing = variant.attributes?.find(
        (a) => parseInt(a.id_attribute_type) === parseInt(at.id)
      );
      return {
        id_attribute_type: at.id,
        nome: at.nome,
        valor: existing?.valor || "",
      };
    }),
  });
  const [dirty, setDirty] = useState(!variant.id);

  function update(field, value) {
    setData((prev) => ({ ...prev, [field]: value }));
    setDirty(true);
  }

  function updateAttribute(atId, valor) {
    setData((prev) => ({
      ...prev,
      attributes: prev.attributes.map((a) =>
        a.id_attribute_type === atId ? { ...a, valor } : a
      ),
    }));
    setDirty(true);
  }

  return (
    <tr>
      <td>
        <Input
          style={{ marginBottom: 0, width: 120 }}
          value={data.id_everest}
          onChange={(e) => update("id_everest", e.target.value)}
          placeholder="Código"
        />
      </td>
      <td>
        <Input
          style={{ marginBottom: 0, width: 80 }}
          value={data.preco}
          onChange={(e) => {
            let val = e.target.value.replace(",", ".");
            update("preco", val);
          }}
          placeholder="Preço"
        />
      </td>
      {attributeTypes.map((at) => {
        const attr = data.attributes.find(
          (a) => a.id_attribute_type === at.id
        );
        return (
          <td key={at.id}>
            <Input
              style={{ marginBottom: 0, width: 80 }}
              value={attr?.valor || ""}
              onChange={(e) => updateAttribute(at.id, e.target.value)}
              placeholder={at.nome}
            />
          </td>
        );
      })}
      <td>
        <select
          value={data.status}
          onChange={(e) => update("status", e.target.value)}
          style={{ padding: 4, borderRadius: 4, border: "1px solid #ccc" }}
        >
          <option value="active">Ativo</option>
          <option value="inactive">Inativo</option>
        </select>
      </td>
      <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
        {dirty && (
          <span
            style={{ cursor: "pointer", marginRight: 10, color: "#3483fa" }}
            onClick={() => {
              if (!data.id_everest || !data.preco) {
                toast.error("Código e preço são obrigatórios na variante");
                return;
              }
              onSave(data);
              setDirty(false);
            }}
          >
            Salvar
          </span>
        )}
        <FontAwesomeIcon
          icon={faMinusCircle}
          color="red"
          style={{ cursor: "pointer" }}
          onClick={onDelete}
        />
      </td>
    </tr>
  );
}

export default Novo;
